"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcMenuV2PopOverMore = void 0;
var bc_pop_over_behavior_1 = require("../../../atoms/bc-pop-over/bc-pop-over-behavior");
var bc_pop_over_constants_1 = require("../../../atoms/bc-pop-over/bc-pop-over-constants");
var bc_accordion_behavior_1 = require("../../../molecules/bc-accordion/bc-accordion-behavior");
var common_constants_1 = require("../../../../common/constants/common-constants");
var helpers_1 = require("../../../../common/helpers");
var bc_menu_v2_constants_1 = require("../bc-menu-v2-constants");
var bc_menu_v2_accordion_1 = require("./bc-menu-v2-accordion");
var BcMenuV2PopOverMore = (function () {
    function BcMenuV2PopOverMore(config) {
        var _this = this;
        this._setListenerOnEventResponsive = function (itemTargetli) {
            itemTargetli.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                var returnEvent = {
                    titleItem: itemTargetli.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG).textContent,
                };
                _this.onEventResponsive(returnEvent, event);
            });
        };
        this.popOverMegaMenu = config.popOverMegaMenu;
        this.listItemsMenu = config.listItemsMenu;
        this.setAccesibilityAriaFalse = config.setAccesibilityAriaFalse;
        this.setAccesibilityAriaTrue = config.setAccesibilityAriaTrue;
        this.arrayInstancesPopOver = config.arrayInstancesPopOver;
        this.configClickListener = config.configClickListener;
        this.closePopOvers = config.closePopOvers;
        this.listItemsMenuArr = config.listItemsMenuArr;
        this.subMenuConfig = config.subMenuConfig;
        this.configHeader = config.configHeader;
        this.configHeaderTablet = config.configHeaderTablet;
        this.isTablet = config.isTablet;
        this.render();
    }
    BcMenuV2PopOverMore.prototype.render = function () {
        this.createPopOverItemMore(this.popOverMegaMenu, this.listItemsMenu);
        this.createListItemMore(this.listItemsMenuArr, this.subMenuConfig);
    };
    BcMenuV2PopOverMore.prototype.createPopOverItemMore = function (popOverMegaMenu, listItemsMenu) {
        var heightPopOver = common_constants_1.COMMON_CONSTANTS_NUMBERS.N500;
        if (this.subMenuConfig.listItemsMenu.length < common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && this.subMenuConfig.logout.state === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
            heightPopOver = common_constants_1.COMMON_CONSTANTS_NUMBERS.N100;
        }
        var popOverElementMore = (0, helpers_1.createElement)({
            element: common_constants_1.BcCommonConstants.SECTION_TAG,
            classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER],
            props: { id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2,
                hiddenArrow: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE,
                buttonClose: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE,
                position: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TOP_LEFT,
                width: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2_WITH,
                height: heightPopOver,
                scroll: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_FALSE,
            },
            children: [(0, helpers_1.createElement)({
                    element: common_constants_1.BcCommonConstants.SECTION_TAG,
                    classList: [bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER],
                    props: { id: bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE }
                })
            ],
        });
        var bodyElement = document.querySelector(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_BODY);
        bodyElement.prepend(popOverElementMore);
        var cloneTargetA = popOverMegaMenu.cloneNode(true);
        var itemTargetli = cloneTargetA.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
        this._setListenerOnEventResponsive(itemTargetli);
        this.createPopOverItemMoreConfig(cloneTargetA);
        listItemsMenu.appendChild(cloneTargetA);
        this.configPopOverItemMoreMobile(popOverElementMore, itemTargetli);
        this.configPopOverBehavior(itemTargetli, cloneTargetA, popOverElementMore);
    };
    BcMenuV2PopOverMore.prototype.createPopOverItemMoreConfig = function (popOverContent) {
        popOverContent.setAttribute(common_constants_1.BcCommonConstants.ARIA_CONTROL, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2);
        popOverContent.setAttribute(common_constants_1.BcCommonConstants.ROLE, common_constants_1.BcCommonConstants.BUTTON_TAG);
        popOverContent.removeAttribute(common_constants_1.BcCommonConstants.ATTR_HREF);
        popOverContent.removeAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TARGET);
        popOverContent.setAttribute(common_constants_1.BcCommonConstants.ID, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ITEM_MORE);
        var iconTargetA = popOverContent.querySelector(".".concat(common_constants_1.BcCommonConstants.ICONS_CLASS));
        iconTargetA.style.textAlign = common_constants_1.BcCommonConstants.CENTER;
        iconTargetA.textContent = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_SECONDARY_MENU;
        iconTargetA.nextSibling.textContent = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_MAS;
        popOverContent.style.display = common_constants_1.BcCommonConstants.BLOCK;
    };
    BcMenuV2PopOverMore.prototype.configPopOverItemMoreMobile = function (popOverMore, itemli) {
        var _this = this;
        var itemTarget = popOverMore.querySelector(".".concat(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_CONTAINER));
        if (window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767) {
            popOverMore.setAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HIDDEN_ARROW, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE);
            popOverMore.setAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_POSITION, bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_ABSOLUTE);
            popOverMore.removeAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_WIDTH);
            popOverMore.removeAttribute(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_PROPERTY_HEIGHT);
            popOverMore.style.width = "".concat(common_constants_1.COMMON_CONSTANTS_NUMBERS.N100, "vw");
            if (this.subMenuConfig.listItemsMenu.length < common_constants_1.COMMON_CONSTANTS_NUMBERS.N5 && this.subMenuConfig.logout.state === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                popOverMore.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N20H;
            }
            else {
                popOverMore.style.height = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N90H;
            }
        }
        else {
            itemTarget.style.maxHeight = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N600X;
        }
        itemli.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            var allActiveElements = document.querySelectorAll(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE));
            allActiveElements.forEach(function (element) {
                _this.setAccesibilityAriaFalse(element);
            });
            if (popOverMore.classList.contains(bc_pop_over_constants_1.BcPopOverConstans.BC_POP_OVER_ACTIVE)) {
                _this.setAccesibilityAriaFalse(itemli);
            }
            else {
                _this.setAccesibilityAriaTrue(itemli);
            }
        });
    };
    BcMenuV2PopOverMore.prototype.configPopOverBehavior = function (itemli, AElement, elementMore) {
        var _this = this;
        var popOverMore = new bc_pop_over_behavior_1.BcPopOverBehavior();
        this.arrayInstancesPopOver.push(popOverMore);
        popOverMore.setId(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2);
        popOverMore.setUp();
        AElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.configClickListener(popOverMore, itemli);
        });
        document.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var element = event.target.offsetParent;
            var parent = event.target.closest('.bc-pop-over-menu-v2');
            if (event.target.closest(common_constants_1.BcCommonConstants.HREF_TAG) !== AElement) {
                if (parent == null && !element.classList.contains('bc-pop-over-target')) {
                    _this.onDeleteClassPressItems();
                    _this.closePopOvers();
                }
            }
        });
        var buttonHeaderMegaMenu = elementMore.firstChild.querySelector(common_constants_1.BcCommonConstants.BUTTON_TAG);
        if (buttonHeaderMegaMenu) {
            buttonHeaderMegaMenu.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                _this.onDeleteClassPressItems();
                popOverMore.closePopOver();
                if (popOverMore.closePopOver) {
                    _this.setAccesibilityAriaFalse(itemli);
                }
            });
        }
        this.configKeyboardListener(AElement, popOverMore, itemli);
    };
    BcMenuV2PopOverMore.prototype.configKeyboardListener = function (popOverconfig, popOverMore, itemli) {
        var _this = this;
        popOverconfig.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            var allowedKeyCodes = [common_constants_1.BcCommonConstants.KEY_EVENT_ENTER, common_constants_1.BcCommonConstants.KEY_EVENT_SPACE];
            if (allowedKeyCodes.includes(event.code)) {
                _this.configClickListener(popOverMore, itemli);
            }
        });
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.setAccesibilityAriaFalse(itemli);
            }
        });
    };
    BcMenuV2PopOverMore.prototype.createListItemMore = function (listItemsMenuArr, subMenuConfig) {
        var _this = this;
        var _a;
        var ulElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.UL_TAG });
        ulElement.style.overflowY = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_AUTO;
        var isTablet = window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767;
        var logoutState = ((_a = subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE;
        if (isTablet) {
            this.configHeader(subMenuConfig.header, document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2)), document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MEGA_MENU_V2)));
        }
        else {
            ulElement.style.maxHeight = logoutState ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N79 : bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N100;
            this.configHeaderTablet(subMenuConfig.header, document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE)));
        }
        for (var index = common_constants_1.COMMON_CONSTANTS_NUMBERS.N4; index < subMenuConfig.listItemsMenu.length; index++) {
            var item = subMenuConfig.listItemsMenu[index];
            if (!item.megaMenu) {
                this.createLink(item, ulElement);
            }
            else {
                this.bcMenuV2Accordion = new bc_menu_v2_accordion_1.BcMenuV2Accordion(listItemsMenuArr, index, ulElement, this.closePopOvers.bind(this), this.isTablet);
                this.bcMenuV2Accordion.onDeleteClassActiveItems = function () { return _this.onDeleteClassActiveItems(); };
                this.bcMenuV2Accordion.onDeleteClassPressItems = function () { return _this.onDeleteClassPressItems(); };
                this.bcMenuV2Accordion.onEventResponsive = function (returnEvent, event) { return _this.onEventResponsive(returnEvent, event); };
            }
        }
        var containerMore = document.querySelector("#".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MORE));
        containerMore === null || containerMore === void 0 ? void 0 : containerMore.appendChild(ulElement);
        this.createInstancesAcordion(subMenuConfig.listItemsMenu);
        this._adjustPopoverHeight(ulElement);
    };
    BcMenuV2PopOverMore.prototype._adjustPopoverHeight = function (ulElement) {
        var _this = this;
        var isMobile = window.innerWidth <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767;
        if (isMobile) {
            setTimeout(function () {
                var _a;
                var screenHeight = window.innerHeight;
                var header = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_HEADER));
                var headerHeight = header ? header.clientHeight : 0;
                var menuHeight = document.querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2)).clientHeight;
                var popOver = document.getElementById(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_POP_OVER_MENU_V2);
                var newHeight = screenHeight - (headerHeight + menuHeight);
                if (((_a = _this.subMenuConfig.logout) === null || _a === void 0 ? void 0 : _a.state) === bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE) {
                    newHeight = newHeight - bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N74;
                }
                popOver.style.height = "".concat(newHeight, "px");
                ulElement.style.height = "".concat(newHeight - common_constants_1.COMMON_CONSTANTS_NUMBERS.N24, "px");
            }, common_constants_1.COMMON_CONSTANTS_NUMBERS.N200);
        }
    };
    BcMenuV2PopOverMore.prototype.createLink = function (item, ulElement) {
        var _a;
        var _this = this;
        var liElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.LI_TAG,
            classList: [bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LIST_ITEMS_MORE],
        });
        var aElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.HREF_TAG,
            classList: [common_constants_1.BcCommonConstants.BC_LINK_CLASS, common_constants_1.BcCommonConstants.BC_LINK_LARGE],
            props: { target: !item.target ? bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_LINK_SELF : item.target },
        });
        var emElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.EM_TAG,
            classList: [common_constants_1.BcCommonConstants.ICONS_CLASS, common_constants_1.BcCommonConstants.ICON_SM_CLASS],
            props: (_a = {}, _a[common_constants_1.BcCommonConstants.ARIA_HIDDEN] = bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TRUE, _a),
            innerText: item.icon, });
        var spanElement = (0, helpers_1.createElement)({ element: common_constants_1.BcCommonConstants.SPAN_TAG, innerText: item.title });
        aElement.appendChild(emElement);
        aElement.appendChild(spanElement);
        liElement.appendChild(aElement);
        aElement.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var textLink = '';
            var spanEl = aElement.querySelector(common_constants_1.BcCommonConstants.SPAN_TAG);
            if (spanEl instanceof HTMLElement) {
                textLink = spanEl.innerText;
            }
            var returnEvent = { textLink: textLink };
            _this.onEventResponsive(returnEvent, event);
            _this.closePopOvers();
            _this.onDeleteClassActiveItems();
            _this.onDeleteClassPressItems();
            var liItem = document.getElementById('bc-item-menu-v2-more').querySelector(".".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2));
            liItem.classList.add("".concat(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_ACTIVE));
        });
        ulElement.appendChild(liElement);
        if (item.isDisabled) {
            aElement.classList.add(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_SUBMENU_V2_DISABLED);
            aElement.removeAttribute(bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_TABINDEX);
        }
        if (item.href) {
            aElement.setAttribute(common_constants_1.BcCommonConstants.ATTR_HREF, item.href);
        }
    };
    BcMenuV2PopOverMore.prototype.createInstancesAcordion = function (listItemsMenu) {
        if (listItemsMenu.length >= common_constants_1.COMMON_CONSTANTS_NUMBERS.N5) {
            for (var index = common_constants_1.COMMON_CONSTANTS_NUMBERS.N4; index < listItemsMenu.length; index++) {
                var submenu = listItemsMenu[index];
                if (!!submenu.megaMenu) {
                    var bcAccordionBehavior = new bc_accordion_behavior_1.BcAccordionBehavior();
                    bcAccordionBehavior.setId("accordionID".concat(index));
                    bcAccordionBehavior.setUp();
                }
            }
        }
    };
    return BcMenuV2PopOverMore;
}());
exports.BcMenuV2PopOverMore = BcMenuV2PopOverMore;
